module.exports = __webpack_public_path__ + "plugins/web/img/小智学习.253055eb.png";